// 2026-09-27 US-010: Loyalty "10 + 1" dashboard (Phase 1, read-only). Mirrors
// EMB.Core/Model/LoyaltyModel.cs; field names are the exact PascalCase API names.

export interface LoyaltyDashboardRequest {
  Email?: string;
  PageNumber: number;
  PageSize: number;
}

export interface LoyaltyCustomerItem {
  // Opaque encrypted key; the raw email is never sent as a request parameter or put in a URL.
  CustomerKey: string;
  Name: string;
  Email: string;
  Qty: number;
  FreeEarned: number;
  ToNextFree: number;
  // At least one invoice has > 20 units: counted, but likely worth checking for a typo.
  HasHighUnitCount: boolean;
}

export interface LoyaltyDashboardResponse {
  Items: LoyaltyCustomerItem[];
  TotalCount: number;
  PageNumber: number;
  PageSize: number;
}

export type LoyaltyUnitCountSource = 'Invoice' | 'BoxDetails' | 'None';

export interface LoyaltyTransactionItem {
  RowNo: number;
  // 2026-09-28 US-010: booking reference replaces the invoice number
  RefNo: string;
  ReceivedDate: string;
  Units: number;
  UnitCountRaw?: string;
  UnitCountSource: LoyaltyUnitCountSource;
  IsInvalidUnitCount: boolean;
  IsHighUnitCount: boolean;
  HasMultipleInvoices: boolean;
  StatusCode: string;
  Status: string;
}

// Found = false is a success response and renders "Customer not found" (AC-24).
export interface LoyaltyCustomerDetailResponse {
  Found: boolean;
  Email?: string;
  Name?: string;
  Qty: number;
  FreeEarned: number;
  ToNextFree: number;
  // 2026-09-28 US-010: units toward the next free one ("n/10"); batch numbering removed
  ProgressUnits: number;
  Transactions: LoyaltyTransactionItem[];
}

export const LoyaltyPageSize = 20;
export const LoyaltyPromoSize = 10;
// Mirrors the > 20 threshold in fn_LoyaltyQualifyingTransactions (display text only).
export const LoyaltyHighUnitCount = 20;
